import React from "react";

export const CopyrightWidget = props => {
    let className = 'text-small text-grey '
    if (typeof props.className !== 'undefined') {
        className += props.className;
    }
    
    return (
        <div style={{marginBottom: 'calc(56px + env(safe-area-inset-bottom))'}}> 
            <div className='ai-legal-container'>
                <div className="margin-bottom-4 margin-top-8 padding-left-16 padding-right-16" style={{fontSize: '1.2em', fontWeight: '600'}}>Notice</div>
                <p className="padding-left-16 padding-right-16" style={{lineHeight: '1.5'}}>
                    You are prohibited from using or uploading content you accessed through this mobile application into external applications, bots, software, or websites, including those using artificial intelligence technologies and infrastructure, including deep learning, machine learning and large language models and generative AI.
                </p>
            </div>

            <div style={{
                textAlign: props.textAlign,
            }} className={className}>
                {typeof props.begin !== 'undefined' && props.begin < props.year
                    ? (
                        <p>&copy; {props.begin} - {props.year} American Urological Association. All Rights Reserved.</p>
                    )
                    : (
                        <p>&copy; {props.year} American Urological Association. All Rights Reserved.</p>
                    )
                }
            </div>
        </div>
    );
};
